
import { CalculatorCategory } from '../../types/calculator.types';

export const professionalCategory: CalculatorCategory = {
  id: 'professional-tools',
  name: 'Professional Tools',
  description: 'Business and technical calculators',
  theme: 'professional',
  icon: 'briefcase',
  calculators: [
    {
      id: 'ai-detector',
      name: 'AI Content Detector',
      description: 'Detect AI-generated content',
      theme: 'professional'
    },
    {
      id: 'hours',
      name: 'Hours Calculator',
      description: 'Calculate work hours and overtime',
      theme: 'professional'
    },
    {
      id: 'productivity',
      name: 'Productivity Calculator',
      description: 'Measure and optimize productivity',
      theme: 'professional'
    },
    {
      id: 'business-loan',
      name: 'Business Loan Calculator',
      description: 'Calculate business loan payments',
      theme: 'professional'
    },
    {
      id: 'sba-loan',
      name: 'SBA Loan Calculator',
      description: 'Calculate SBA loan terms',
      theme: 'professional'
    },
    {
      id: 'equipment-loan',
      name: 'Equipment Loan Calculator',
      description: 'Calculate equipment financing',
      theme: 'professional'
    },
    {
      id: 'paint',
      name: 'Paint Calculator',
      description: 'Calculate how much paint you need for your room based on dimensions',
      theme: 'professional'
    },
    {
      id: 'tile',
      name: 'Tile Calculator',
      description: 'Calculate how many tiles you need for your project based on area and tile size',
      theme: 'professional'
    },
    {
      id: 'roi',
      name: 'ROI Calculator',
      description: 'Calculate return on investment for business decisions and projects',
      theme: 'professional'
    },
    {
      id: 'break-even',
      name: 'Break-Even Point Calculator',
      description: 'Calculate break-even point for your business or product',
      theme: 'professional'
    },
    {
      id: 'freelance-rate',
      name: 'Freelance Rate Calculator',
      description: 'Calculate optimal hourly and project rates for freelance work',
      theme: 'professional'
    },
    {
      id: 'employee-cost',
      name: 'Employee Cost Calculator',
      description: 'Calculate total employment costs including salary, benefits, and overhead',
      theme: 'professional'
    },
    {
      id: 'conversion-rate',
      name: 'Conversion Rate Calculator',
      description: 'Calculate and optimize marketing conversion rates',
      theme: 'professional'
    },
    {
      id: 'customer-lifetime-value',
      name: 'Customer Lifetime Value Calculator',
      description: 'Calculate customer lifetime value and revenue projections',
      theme: 'professional'
    }
  ]
};

export default professionalCategory;
